import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { MultiselectorDescripcionPaqueteList } from "./multiselectordescripcionpaquetes";

type Entity = models.ClienteDescripcionPaquete;
export interface Props extends kea.ModalProps<number[], boolean, number> {
}


/**
* Modal de edición para un ClienteDescripcionPaquete
*/
export class ClienteDescripcionPaqueteEdit extends React.PureComponent<Props> {

    idCliente = (props: Props) => props.params;
    value = (props: Props) => props.value;
    items = createSelectorRx(this.idCliente, idCliente => observeResource(resources.ClientePaquete.DescripcionesPaquetesClientePuedeAgregar, idCliente));

    getField = formfields(() => this.props);

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }

    onChange = async (x: number[]) => {
        this.props.onChange(x);
    }

    render() {
        const value = this.value(this.props);
        const items = this.items(this.props);

        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} />]}
                onClose={this.onCerrar}
                title="seleccionar descripciones de paquetes"
            >
                <kea.Title titulo={"Seleccionar descripciones de paquetes"} >
                </kea.Title>
                <MultiselectorDescripcionPaqueteList value={value} onChange={this.onChange} items={items} />
            </kea.Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/clientes/edit/componentes/tabs/descripcionpaquetes/edit.tsx